import { RequiredCustomerWarning } from '~/purchase/components';
import { usePurchaseContext } from '~/purchase/context';
import { Navigate } from 'react-router';

export default function QuoteCustomerProtected({
  component: Component,
  express = false,
}: {
  component: React.ComponentType;
  express?: boolean;
}) {
  const { state } = usePurchaseContext();

  if (express && !state.targetCustomer?.expressQuoteSearchable) {
    return <Navigate to='/quotes' replace />;
  }

  if (state.targetCustomer?.quoteSearchable) {
    return <Component />;
  }
  return <RequiredCustomerWarning />;
}
